import React from "react"
import ReactDOM from "react-dom"
import LinkListAccordion from "./link-list-accordion-component"

export default class LinkListAccordionModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<LinkListAccordion {...self.modelJson} />, self.elem)
  }
}
